export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8909.9bd29272.jpg";